import { DownloadAsExcel } from './downloadAsExcel';
import { flatten } from 'flat';
import { momentTimeFormater } from './timeHelper';
import { get as lodashGet, set as lodashSet } from 'lodash';

export const DownloadFileFromBuffer = async (buffer, fileName, fileType) => {
    const blob = new Blob([buffer], {
        type: fileType,
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

export const exportData = (data = [], fileName = '', keys = [], extraData = null) => {
    let columnIndex = 0;
    let columnLength = 0;
    let isTs = false;
    const flattenedData = data
        .map((el) => flatten(el, { delimiter: '_' }))
        .map((originalItem, index) => {
            let item = originalItem;
            // if keys are provided then only pick those keys.
            if (keys.length) {
                const temp = {};
                keys.forEach((key) => {
                    lodashSet(temp, key, lodashGet(originalItem, key));
                });
                item = temp;
            }

            if (item?._id) delete item?._id;
            delete item?.__v;
            let tsCET;

            // Convert timestamp to timestamp CET'
            if (item?.timestamp) {
                isTs = true;
                tsCET = momentTimeFormater(item.timestamp).format('YYYY-MM-DD HH:mm:ss');
                delete item?.timestamp;
            }
            // Convert startTime to startTime CET'
            if (item?.startTime) {
                item.startTimeCET = momentTimeFormater(item.startTime).format('YYYY-MM-DD HH:mm:ss');
                delete item?.startTime;
            }
            // Convert endTime to endTime CET'
            if (item?.endTime) {
                item.endTimeCET = momentTimeFormater(item.endTime).format('YYYY-MM-DD HH:mm:ss');
                delete item?.endTime;
            }

            const objectLength = Object.keys(item).length;
            if (objectLength > columnLength) {
                columnLength = objectLength;
                columnIndex = index;
            }
            return {
                ...(isTs ? { timestampCET: tsCET } : {}),
                ...item,
            };
        });

    const columnNames = [...(isTs ? ['TIMESTAMP CET'] : [])];
    for (let key in flattenedData[columnIndex]) {
        if (key !== 'timestampCET') columnNames.push(key.toUpperCase());
    }

    if (extraData) flattenedData.push(extraData);

    flattenedData?.length > 0 && DownloadAsExcel(flattenedData, fileName, columnNames, columnIndex);
};
